import {Injectable} from '@angular/core';
import {} from 'ionic-angular';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Services
import {rsSessionSvc} from './auth.service';
import {rsProjectSvc, IProjectType, IProjectDetails} from './project.service';
import {IEmployee} from './employee.service';

export enum ReportState {
  Activity,
  Labor,
  Subcontractor,
  Equipment,
  Inspections,
  PurchaseOrders,
  Pictures,
  OrdersReceived,
  AdditionalNotes,
  OnSchedule,
  ScheduleImpacts
}

// Interfaces
export interface IReportInfo {
  project_id: number;
  creator: IEmployee;
  date: string;
  time: string;
} 

export interface IReportData {
  on_schedule: string;
  schedule_impacts: string;
  orders_received: string;
  additional_notes: string;
}

export interface IReportState {
  activities: number;
  labor: number;
  subcontractors: number;
  equipment: number;
  inspections: number;
  purchase_orders: number;
  pictures: number;
  orders_received: boolean;
  additional_notes: boolean;
  on_schedule: boolean;
  schedule_impacts: boolean;
}

export interface IReportWeather {
  logo: string;
  temp_hi: number;
  temp_lo: number;
  weather: string;
  icon: string;
  rainchance: number;
  humidity: number;
  windspeed: number;
}

export interface IReportDetails {
  id: number;
  info: IReportInfo;
  report: IReportData;
  state: IReportState;
  weather: IReportWeather;
  project: IProjectDetails;
}

export interface IReport {
  id: number;
  projectname: string;
  jobnumber: number;
  date: string;
  time: string;
  projecttype: IProjectType;
}

@Injectable()
export class rsReportSvc 
{
  // Private variables
  reportData : IReportDetails = undefined;

  constructor(
    public http: Http, 
    private sessionSvc : rsSessionSvc,
    private projectSvc : rsProjectSvc) {
    // Class constructor
  }

  getActiveReportId() : number {
    if( this.reportData === undefined ) return undefined;
    return this.reportData.id;
  }

  getActiveReport() : IReportDetails {
    return this.reportData;
  }

  getReports() : Observable<IReport[]> {
    // Return an observerable object 
    return Observable.create( observer => {

      // Retrieve the creatorid from the current session data 
      let creatorId: number = this.sessionSvc.getUserId();

      // This method runs when a function subscribes 
      this.http.get( 'http://dfr.hydrocon.com/api/v1/report/filter/creator/' + creatorId, {
        withCredentials: true
      })
      .map( res => {
        return res.json().response.reports;
      })
      .subscribe( result => {
        // Store our current report data 
        observer.next(result);
      }, err => {
        observer.error(err);
      }, () => {
        observer.complete();
      });
    });
  }
  createReport( projectId : number, setActive : boolean = true, updateLast : boolean = false ) : Observable<IReportDetails> {
    // Return an observable object 
    return Observable.create( observer => {
      
      // Get the current user id
      let creatorId : number = this.sessionSvc.getUserId();
      if( creatorId === 0 ) observer.error('Invalid CreatorID');

      // Setup our request data 
      let postData = { 
        creatorid: creatorId,
        projectid: projectId
      }
      let body : string = JSON.stringify(postData);
      let headers : Headers = new Headers({ 
        'Content-Type' : 'application/json'
      });
      let options : RequestOptions = new RequestOptions({
        headers: headers, 
        withCredentials: true 
      });

      // Submit our request
      this.http.post( 'http://dfr.hydrocon.com/api/v1/report', body, options)
      .map( res => res.json().response )
      .subscribe( result => 
      {
        // Now we need to get our project information
        this.projectSvc.getProject( result.info.project_id ).subscribe( projectResult => {
          // Copy our report result into our data structure 
          let data : IReportDetails = result;
          // // Copy our projectResult into our data structure
          data.project = projectResult;

          // If this report is to become the active report, then we set the class state accordingly
          if( setActive ) this.reportData = data;
          
          // Finally, let's update our user
          if( updateLast == true ) {
            this.sessionSvc.updateLastReport( data.id ).subscribe( updateResult => {
              // Successful
            }, updateErr => {
              // Ignore error and continue
              observer.next(data);
            }, () => {
              observer.next(data);
            });
          } else {
              // Operation successful
              observer.next(data);
          }
        }, projectErr => {
          // An error occurred retrieving project info so the entire function fails
          observer.error(projectErr);
        }, () => {
          observer.complete();          
        });
      }, err => {
        observer.error(err); 
      });
    });
  }
  getRecentReport( setActive: boolean = true) : Observable<IReportDetails> {
    return Observable.create( observer => {
       
      // Get a copy of our user id to help us determine if we have 
      let creatorId : number = this.sessionSvc.getUserId();

      this.http.get( 'http://dfr.hydrocon.com/api/v1/report/filter/creator/' + creatorId + '/recent', { 
        withCredentials: true 
      })
      .map( res => res.json().response )
      .subscribe( result => 
      {

        // Now we need to get our project information
        this.projectSvc.getProject( result.info.project_id ).subscribe( projectResult => {

          // Copy our report result into our data structure 
          let data : IReportDetails = result;
          // // Copy our projectResult into our data structure
          data.project = projectResult;

          // If this report is to become the active report, then we set the class state accordingly
          if( setActive ) this.reportData = data;
          
          // Operation successful
          observer.next(data);
        }, projectErr => {
          // An error occurred retrieving project info so the entire function fails
          observer.error(projectErr);
        }, () => {
          observer.complete();          
        });
      }, err => {
        observer.error(err); 
      });     
    });
  }
  getReport( id: number, setActive : boolean = true, updateLast : boolean = false ) : Observable<IReportDetails> {
    // Return an observable object 
    return Observable.create( observer => { 
      
      this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + id, {
        withCredentials: true 
      })
      .map( res => res.json().response )
      .subscribe( result => 
      {
        // Now we need to get our project information
        this.projectSvc.getProject( result.info.project_id )
        .subscribe( projectResult => {
          // Copy our report result into our data structure 
          let data : IReportDetails = result;
          // // Copy our projectResult into our data structure
          data.project = projectResult;

          // If this report is to become the active report, then we set the class state accordingly
          if( setActive ) this.reportData = data;          

          // Finally, let's update our user
          if( updateLast == true ) {
            this.sessionSvc.updateLastReport( id ).subscribe( updateResult => {
              // Successful
            }, updateErr => {
              // Ignore error and continue
              observer.next(data);
            }, () => {
              observer.next(data);
            });
          } else {
              // Operation successful
              observer.next(data);
          }
        }, projectErr => {
          // An error occurred retrieving project info so the entire function fails
          observer.error(projectErr);
        }, () => {
          observer.complete();          
        });
      }, err => {
        observer.error(err); 
      });
    });
  }

  updateOrdersReceived( reportId : number, notes: string ) : Observable<IReportDetails> {
    return Observable.create( observer => {

      // Get the current user id
      let creatorId : number = this.sessionSvc.getUserId();
      if( creatorId === 0 ) observer.error('Invalid CreatorID');

      // Setup our request data 
      let postData = { 
        creatorid: creatorId,
        orders_received: notes
      }
      let body : string = JSON.stringify(postData);
      let headers : Headers = new Headers({ 
        'Content-Type' : 'application/json'
      });
      let options : RequestOptions = new RequestOptions({
        headers: headers, 
        withCredentials: true 
      });      

      // Submit our request
      this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId , body, options)
      .map( res => res.json().response )
      .subscribe( (result : IReportDetails) => 
      {      
        // If the report has a matching id, then let's update our stored instance
        if( result.id === this.reportData.id ) {
          this.reportData.report.orders_received = result.report.orders_received;
          this.reportData.state.orders_received = result.state.orders_received;
        }
          // Operation successful
          observer.next(result);
      }, err => {
        observer.error(err);
      }, () => {  
        observer.complete();
      });
    });
  }

  updateScheduleImpacts( reportId : number, onSchedule : boolean, scheduleImpacts: string ) : Observable<IReportDetails> {
    return Observable.create( observer => {

      // Get the current user id
      let creatorId : number = this.sessionSvc.getUserId();
      if( creatorId === 0 ) observer.error('Invalid CreatorID');

      // Setup our request data 
      let postData = { 
        creatorid: creatorId,
        on_schedule: onSchedule,
        schedule_impacts: scheduleImpacts
      }
      let body : string = JSON.stringify(postData);
      let headers : Headers = new Headers({ 
        'Content-Type' : 'application/json'
      });
      let options : RequestOptions = new RequestOptions({
        headers: headers, 
        withCredentials: true 
      });      

      // Submit our request
      this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId , body, options)
      .map( res => res.json().response )
      .subscribe( (result : IReportDetails) => 
      {      
        // If the report has a matching id, then let's update our stored instance
        if( result.id === this.reportData.id ) 
        {
          this.reportData.report.schedule_impacts = result.report.schedule_impacts;
          this.reportData.report.on_schedule = result.report.on_schedule;
          this.reportData.state.schedule_impacts = result.state.schedule_impacts;
          this.reportData.state.on_schedule = result.state.on_schedule;
        }
          // Operation successful
          observer.next(result);
      }, err => {
        observer.error(err);
      }, () => {  
        observer.complete();
      });
    });
  }    

  updateAdditionalNotes( reportId : number, notes: string ) : Observable<IReportDetails> {
    return Observable.create( observer => {

      // Get the current user id
      let creatorId : number = this.sessionSvc.getUserId();
      if( creatorId === 0 ) observer.error('Invalid CreatorID');

      // Setup our request data 
      let postData = { 
        creatorid: creatorId,
        additional_notes: notes
      }
      let body : string = JSON.stringify(postData);
      let headers : Headers = new Headers({ 
        'Content-Type' : 'application/json'
      });
      let options : RequestOptions = new RequestOptions({
        headers: headers, 
        withCredentials: true 
      });      

      // Submit our request
      this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId , body, options)
      .map( res => res.json().response )
      .subscribe( (result : IReportDetails) => 
      {      
        // If the report has a matching id, then let's update our stored instance
        if( result.id === this.reportData.id ) {
          this.reportData.report.additional_notes = result.report.additional_notes;
          this.reportData.state.additional_notes = result.state.additional_notes;
        }
          // Operation successful
          observer.next(result);
      }, err => {
        observer.error(err);
      }, () => {  
        observer.complete();
      });
    });
  }  
}



// WEBPACK FOOTER //
// ./src/services/report.service.ts